(($) => {
    $(document).on('ready', init);

    function init() {
        bind();
    }

    function bind() {
        $('html').on('bb-lumeris:lum-button:init', moduleInit);
    }

    function moduleInit(event, data) {
        if (!event || !data) {
            return false;
        }

        const $module = $(`.fl-node-${data.node}`);
        
        $module.find('a').on('click', (event) => {
            document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'cta_link_click' }}));
        });
    }
})(jQuery);